<template>
  <div class="bg-white-wrapper">
    <div class="container buy-success-wrapper">
      <div class="buy-success-header">
        <Icon type="md-checkmark-circle" />支付成功
      </div>
      <div class="buy-success-info">
        <div class="buy-success-image">
          <img src="../../assets/images/pay-success-book.png" />
        </div>
        <div class="buy-success-text">
          订单已支付成功！
          <span>去学习咯~~</span>
        </div>
        <div class="buy-success-btn">
          <Button
            type="info"
            :to="{ name: 'MemberCenter' }"
            size="large"
            title="进入学习中心"
            >进入学习中心</Button
          >
        </div>
      </div>
    </div>

    <Modal
      v-model="codeModalVisible"
      :closable="false"
      :mask-closable="true"
      width="400"
      height="400"
      class-name="vertical-center-modal"
      footer-hide
    >
      <div class="modal-wrap">
        <div class="modal-qrcode">
          <img :src="concatImageUrl(codeUrl)" title="qrCode" />
        </div>
        <p class="modal-tips">
          {{ codeTips }}
        </p>
      </div>
    </Modal>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { order } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      codeModalVisible: false,
      codeUrl: "",
      codeTips: "",
    };
  },
  mounted() {
    this.setMetaData("支付成功");
    this.getAttractCode();
  },
  methods: {
    getAttractCode() {
      order.getAttractQrCode(this.siteConfig.agencyId || 9).then((res) => {
        console.log("aaa", res);
        if (res.status == 1) {
          if (res.data.attractSwitch == 1) {
            this.codeUrl = res.data.attractQrCode;
            this.codeTips = res.data.attractTips;
            this.codeModalVisible = true;
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.buy-success-wrapper {
  .buy-success-header {
    padding: 20px 0;
    font-size: 1.8rem;
    font-weight: bold;
    i {
      font-size: 5rem;
      margin-right: 10px;
      vertical-align: middle;
      color: #e71f19;
    }
  }
  .buy-success-info {
    padding: 50px 50px;
    background-color: #fff;
    border: 1px solid #f0f0f0;
    text-align: center;
    .buy-success-image {
      text-align: center;
      img {
        margin: 0 auto;
      }
    }
    .buy-success-text {
      font-size: 2.4rem;
      margin: 10px 0;
      span {
        color: #1296db;
      }
    }
    .buy-success-btn {
      margin-top: 30px;
    }
  }
}
.modal-wrap {
  width: 462px;
  height: 419px;
  margin: -24px -48px -48px -48px;
  padding-top: 96px;
  background: url("../../assets/images/attract-bg.png") no-repeat center;
  .modal-qrcode {
    margin: 0 auto;
    width: 170px;
    height: 170px;
    padding: 8px;
    background: #fff;
    img {
      width: 100%;
    }
  }
  .modal-tips {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    padding-top: 16px;
    color: #fff;
    word-break: break-all;
  }
}
</style>
